import Vue from 'vue';
import Router from 'vue-router';
import Profile from '@/dex-shared/components/Profile.vue';
import store from '@/store/index';
import { loginURL } from '@/dex-shared/settings/endpoints';
import Home from './views/Home.vue';

import ExamGroupIndex from './views/exam_group/ExamGroupIndex.vue';
import ExamGroupShow from './views/exam_group/ExamGroupShow.vue';
import ExamGroupEditor from './views/exam_group/ExamGroupEditor.vue';

import ExamIndex from './views/exam/ExamIndex.vue';
import ExamShow from './views/exam/ExamShow.vue';
import ExamEditor from './views/exam/ExamEditor.vue';

import ExamModeIndex from './views/exam_modes/ExamModeIndex.vue';
import ExamModeEditor from './views/exam_modes/ExamModeEditor.vue';

import QuestionIndex from './views/question/QuestionIndex.vue';
import QuestionShow from './views/question/QuestionShow.vue';
import QuestionEditor from './views/question/QuestionEditor.vue';

import ExaminationBoardEditor from './views/examination_board/ExaminationBoardEditor.vue';
import ExaminationBoardIndex from './views/examination_board/ExaminationBoardIndex.vue';

import InstitutionEditor from './views/institution/InstitutionEditor.vue';
import InstitutionIndex from './views/institution/InstitutionIndex.vue';

import ExamApplicationEditor from './views/exam_application/ExamApplicationEditor.vue';
import ExamApplicationIndex from './views/exam_application/ExamApplicationIndex.vue';

import SolutionEditor from './views/solution/SolutionEditor.vue';

import ArticleIndex from './views/article/ArticleIndex.vue';
import ArticleEditor from './views/article/ArticleEditor.vue';
import ArticleShow from './views/article/ArticleShow.vue';

import ListIndex from './views/list/ListIndex.vue';
import ListShow from './views/list/ListShow.vue';
import ListEditor from './views/list/ListEditor.vue';
import ListReport from './views/list/ListReport.vue';

import VideoEditor from './views/video/VideoEditor.vue';

import BoardIndex from './views/board/BoardIndex.vue';
import BoardShow from './views/board/BoardShow.vue';
import BoardEditor from './views/board/BoardEditor.vue';

import ClassroomIndex from './views/classroom/ClassroomIndex.vue';
import ClassroomShow from './views/classroom/ClassroomShow.vue';
import ClassroomEditor from './views/classroom/ClassroomEditor.vue';

import CourseIndex from './views/course/CourseIndex.vue';
import CourseShow from './views/course/CourseShow.vue';
import CourseEditor from './views/course/CourseEditor.vue';

import FeedbackQuestionIndex from './views/feedback_question/FeedbackQuestionIndex.vue';
import FeedbackQuestionShow from './views/feedback_question/FeedbackQuestionShow.vue';

import ReportIndex from './views/report/ReportIndex.vue';

import BoardSectionIndex from './views/board_section/BoardSectionIndex.vue';
import BoardSectionShow from './views/board_section/BoardSectionShow.vue';
import BoardSectionEditor from './views/board_section/BoardSectionEditor.vue';

import BoardSubsectionShow from './views/board_subsection/BoardSubsectionShow.vue';
import BoardSubsectionEditor from './views/board_subsection/BoardSubsectionEditor.vue';

import UserIndex from './views/user/UserIndex.vue';

import TreeEditor from './views/knowledges_tree/TreeEditor.vue';
import AssociationRedefiner from './views/knowledges_tree/AssociationRedefiner.vue';

import PageNotFound from './views/PageNotFound.vue';

import Reports from './views/schools/Reports.vue';
import Managers from './views/schools/Managers.vue';
import Weekplans from './views/schools/Weekplans.vue';

Vue.use(Router);

const isAuthenticated = () =>
  !!((store.state as any).auth.user && (store.state as any).auth.user.id);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/404',
      name: '404',
      component: PageNotFound,
    },
    {
      path: '/simulados',
      name: 'exam_group_index',
      component: ExamGroupIndex,
    },
    {
      path: '/simulados/:page',
      name: 'exam_group_index_page',
      component: ExamGroupIndex,
    },
    {
      path: '/criar_simulado',
      name: 'exam_group_create',
      component: ExamGroupEditor,
    },
    {
      path: '/editar_simulado/:examGroupId',
      name: 'exam_group_edit',
      component: ExamGroupEditor,
    },
    {
      path: '/simulado/:examGroupId',
      name: 'exam_group_show',
      component: ExamGroupShow,
    },
    {
      path: '/formatos',
      name: 'exam_mode_index',
      component: ExamModeIndex,
    },
    {
      path: '/formatos/:page',
      name: 'exam_mode_index_page',
      component: ExamModeIndex,
    },
    {
      path: '/criar_formato',
      name: 'exam_mode_create',
      component: ExamModeEditor,
    },
    {
      path: '/editar_formato/:examModeId',
      name: 'exam_mode_edit',
      component: ExamModeEditor,
    },
    {
      path: '/provas',
      name: 'exam_index',
      component: ExamIndex,
    },
    {
      path: '/provas/:page',
      name: 'exam_index_page',
      component: ExamIndex,
    },
    {
      path: '/criar_prova',
      name: 'exam_create',
      component: ExamEditor,
    },
    {
      path: '/editar_prova/:examId',
      name: 'exam_edit',
      component: ExamEditor,
    },
    {
      path: '/prova/:examId',
      name: 'exam_show',
      component: ExamShow,
    },

    {
      path: '/questoes',
      name: 'question_index',
      component: QuestionIndex,
    },
    {
      path: '/questoes/:page',
      name: 'question_index_page',
      component: QuestionIndex,
    },
    {
      path: '/criar_questao',
      name: 'question_create',
      component: QuestionEditor,
    },
    {
      path: '/editar_questao/:questionId',
      name: 'question_edit',
      component: QuestionEditor,
    },
    {
      path: '/questao/:questionId',
      name: 'question_show',
      component: QuestionShow,
    },
    {
      path: '/questao/:questionId/criar_solucao',
      name: 'solution_create',
      component: SolutionEditor,
    },

    {
      path: '/bancas',
      name: 'examination_board_index',
      component: ExaminationBoardIndex,
    },
    {
      path: '/bancas/:page',
      name: 'examination_board_index_page',
      component: ExaminationBoardIndex,
    },
    {
      path: '/criar_banca',
      name: 'examination_board_create',
      component: ExaminationBoardEditor,
    },
    {
      path: '/editar_banca/:examinationBoardId',
      name: 'examination_board_edit',
      component: ExaminationBoardEditor,
    },

    {
      path: '/instituicoes',
      name: 'institution_index',
      component: InstitutionIndex,
    },
    {
      path: '/instituicoes/:page',
      name: 'institution_index_page',
      component: InstitutionIndex,
    },
    {
      path: '/criar_instituicao',
      name: 'institution_create',
      component: InstitutionEditor,
    },
    {
      path: '/editar_instituicao/:InstitutionId',
      name: 'institution_edit',
      component: InstitutionEditor,
    },

    {
      path: '/fontes',
      name: 'exam_application_index',
      component: ExamApplicationIndex,
    },
    {
      path: '/fontes/:page',
      name: 'exam_application_index_page',
      component: ExamApplicationIndex,
    },
    {
      path: '/criar_fonte',
      name: 'exam_application_create',
      component: ExamApplicationEditor,
    },
    {
      path: '/editar_fonte/:examApplicationId',
      name: 'exam_application_edit',
      component: ExamApplicationEditor,
    },

    {
      path: '/editar_solucao/:solutionId',
      name: 'solution_edit',
      component: SolutionEditor,
    },

    {
      path: '/explicacoes',
      name: 'article_index',
      component: ArticleIndex,
    },
    {
      path: '/explicacoes/:page',
      name: 'article_index_page',
      component: ArticleIndex,
    },
    {
      path: '/criar_explicacao',
      name: 'article_create',
      component: ArticleEditor,
    },
    {
      path: '/editar_explicacao/:articleId',
      name: 'article_edit',
      component: ArticleEditor,
    },
    {
      path: '/explicacao/:articleId',
      name: 'article_show',
      component: ArticleShow,
    },

    {
      path: '/listas',
      name: 'list_index',
      component: ListIndex,
    },
    {
      path: '/listas/:page',
      name: 'list_index_page',
      component: ListIndex,
    },
    {
      path: '/criar_lista',
      name: 'list_create',
      component: ListEditor,
    },
    {
      path: '/editar_lista/:listId',
      name: 'list_edit',
      component: ListEditor,
    },
    {
      path: '/editar_video/:videoId',
      name: 'video_edit',
      component: VideoEditor,
    },
    {
      path: '/lista/:listId',
      name: 'list_show',
      component: ListShow,
    },
    {
      path: '/lista/:listId/relatorio',
      name: 'report',
      component: ListReport,
    },
    {
      path: '/lista/:listId/:itemId',
      name: 'list_show',
      component: ListShow,
    },

    {
      path: '/murais',
      name: 'board_index',
      component: BoardIndex,
    },
    {
      path: '/criar_mural',
      name: 'board_create',
      component: BoardEditor,
    },
    {
      path: '/editar_mural/:boardId',
      name: 'board_edit',
      component: BoardEditor,
    },
    {
      path: '/mural/:boardId',
      name: 'board_show',
      component: BoardShow,
    },

    {
      path: '/turmas',
      name: 'classroom_index',
      component: ClassroomIndex,
    },
    {
      path: '/criar_turma',
      name: 'classroom_create',
      component: ClassroomEditor,
    },
    {
      path: '/editar_turma/:classroomId',
      name: 'classroom_edit',
      component: ClassroomEditor,
    },
    {
      path: '/turma/:classroomId',
      name: 'classroom_show',
      component: ClassroomShow,
    },

    {
      path: '/cursos',
      name: 'course_index',
      component: CourseIndex,
    },
    {
      path: '/cursos/:page',
      name: 'cursos_index_page',
      component: CourseIndex,
    },
    {
      path: '/criar_curso',
      name: 'course_create',
      component: CourseEditor,
    },
    {
      path: '/editar_curso/:courseId',
      name: 'course_edit',
      component: CourseEditor,
    },
    {
      path: '/curso/:courseId',
      name: 'course_show',
      component: CourseShow,
    },

    {
      path: '/perguntas',
      name: 'feedback_question_index',
      component: FeedbackQuestionIndex,
    },
    {
      path: '/perguntas/:page',
      name: 'feedback_question_index_page',
      component: FeedbackQuestionIndex,
    },
    {
      path: '/pergunta/:feedbackQuestionId',
      name: 'feedback_question_show',
      component: FeedbackQuestionShow,
    },
    {
      path: '/reports',
      name: 'report_index',
      component: ReportIndex,
    },
    {
      path: '/reports/:page',
      name: 'report_index_page',
      component: ReportIndex,
    },
    {
      path: '/secoes',
      name: 'board_section_index',
      component: BoardSectionIndex,
    },
    {
      path: '/secao/:boardSectionId',
      name: 'board_section_show',
      component: BoardSectionShow,
    },
    {
      path: '/editar_secao/:boardSectionId',
      name: 'board_section_edit',
      component: BoardSectionEditor,
    },
    {
      path: '/criar_secao/',
      name: 'board_section_create',
      component: BoardSectionEditor,
    },
    {
      path: '/subsecao/:boardSubsectionId',
      name: 'board_subsection_show',
      component: BoardSubsectionShow,
    },
    {
      path: '/criar_subsecao/',
      name: 'board_subsection_create',
      component: BoardSubsectionEditor,
    },
    {
      path: '/editar_subsecao/:boardSubsectionId',
      name: 'board_subsection_edit',
      component: BoardSubsectionEditor,
    },
    {
      path: '/perfil',
      name: 'profile',
      component: Profile,
    },

    {
      path: '/admins/',
      name: 'user_index',
      component: UserIndex,
    },

    {
      path: '/criar_conhecimento',
      name: 'knowledge_create',
      component: TreeEditor,
    },

    {
      path: '/refinir_associacoes',
      name: 'redefine_knowledges',
      component: AssociationRedefiner,
    },
    {
      path: '/entrar',
      name: 'login',
      beforeEnter() {
        const path = encodeURIComponent(window.location.href);
        const loginPath = `${loginURL}/?returnUrl=${path}`;
        window.location.assign(loginPath);
      },
    },
    {
      path: '/escolas/relatorios',
      name: 'schools_reports',
      component: Reports,
    },
    {
      path: '/escolas/gestores',
      name: 'school_managers',
      component: Managers,
    },
    {
      path: '/escolas/planejamento',
      name: 'school_weekplanning',
      component: Weekplans,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, _from, next) => {
  if (!isAuthenticated() && to.name !== 'login') {
    router.push({ name: 'login' });
  } else {
    next();
  }
});

export default router;
